(function() {
    'use strict';

    angular.module( APP_ID )
        .config([ '$httpProvider', '$sceDelegateProvider', '$stateProvider', '$urlMatcherFactoryProvider', '$urlRouterProvider', '$locationProvider', 'AppProvider', 'CONFIG', AppRouter ]);

    /**
     * Handles routing behavior (forwarding, defaults etc.), URL routes and
     * their query parameters.
     *
     * @param {ng.IHttpService} $httpProvider
     * @param {ng.ISCEDelegateProvider} $sceDelegateProvider
     * @param {uirouter.StateProvider} $stateProvider
     * @param {uirouter.UrlMatcherFactoryProvider} $urlMatcherFactoryProvider
     * @param {uirouter.UrlRouterProvider} $urlRouterProvider
     * @param {ng.ILocationProvider} $locationProvider
     * @param {AppProvider} AppProvider
     * @param {Object} CONFIG
     */
    function AppRouter(
        $httpProvider,
        $sceDelegateProvider,
        $stateProvider,
        $urlMatcherFactoryProvider,
        $urlRouterProvider,
        $locationProvider,
        AppProvider,
        CONFIG
    ){
        /* ===== ROUTING PARAMETERS ========================================= */

        /**
         * URL Query parameters.
         *
         * @type {uirouter.ParamDeclaration}
         */
        var modeParam       = {
            value:  undefined,
            squash: true
        },

        internationalParam  = {
            value:  undefined,
            squash: true
        },

        primaryMajorParam   = {
            value:      null,
            dynamic:    true
        },

        secondaryMajorParam = {
            value:      null,
            dynamic:    true
        },

        subjectsParam = {
            value:      null,
            dynamic:    true,
            array:      'auto' // Array for subjects on study areas; single attribute for programmes
        },

        subjectParam = {
            value:      null,
            dynamic:    true
        },

        programmeParam = {
            value:      null,
            dynamic:    true
        },

        specialisationParam = {
            value:      null,
            dynamic:    true
        },

        // Categories using postgraduate programme template: postgraduate-programmes || graduate-quals || other-quals
        qualTypeParam = {
            value: CONFIG.ROUTES.POSTGRADS
        };

        /**
         * Object containing query parameter IDs as keys and
         * {uirouter.ParamDeclaration} as their values. Should
         * be assigned to {uirouter.StateDeclaration.params}.
         *
         * @type {Object}
         */
        var appParamsSet        = {},
        degreesParamsSet        = {},
        studyAreasParamsSet     = {},
        postgradsParamsSet      = {},
        postgradAreasParamsSet  = {};


        // Params shared by the entire application (~ available everywhere)
        appParamsSet[ CONFIG.PARAMS.MODE ]  = modeParam;

        // Params available only on certain states
        studyAreasParamsSet[ CONFIG.PARAMS.SUBJECT ]         = subjectsParam;
        studyAreasParamsSet[ CONFIG.PARAMS.INTERNATIONAL ]   = internationalParam;

        postgradAreasParamsSet[ CONFIG.PARAMS.INTERNATIONAL ] = internationalParam;

        degreesParamsSet[ CONFIG.PARAMS.PRIMARY_MAJOR ]      = primaryMajorParam;
        degreesParamsSet[ CONFIG.PARAMS.SECONDARY_MAJOR ]    = secondaryMajorParam;
        degreesParamsSet[ CONFIG.PARAMS.INTERNATIONAL ]      = internationalParam;

        postgradsParamsSet[ CONFIG.PARAMS.QUAL_TYPE ]        = qualTypeParam;
        postgradsParamsSet[ CONFIG.PARAMS.SUBJECT ]          = subjectParam;
        postgradsParamsSet[ CONFIG.PARAMS.PROGRAMME ]        = programmeParam;
        postgradsParamsSet[ CONFIG.PARAMS.SPECIALISATION ]   = specialisationParam;
        postgradsParamsSet[ CONFIG.PARAMS.INTERNATIONAL ]    = internationalParam;


        /* ===== ROUTING STATES ============================================= */

        /** @type {uirouter.StateDeclaration} */
        var stateRoot = {
            abstract:   true,
            name:       'app',
            url:        '?' + CONFIG.PARAMS.MODE,
            params:     appParamsSet,
            component:  'basePage'
        },

        /** 404 - Not found page. */
        state404 = {
            parent:      stateRoot,
            name:        CONFIG.STATES.NOT_FOUND,
            url:         '*path',
            component:   'notFound'
        },

        stateServer404 = {
            parent:      stateRoot,
            name:        CONFIG.STATES.SERVER_NOT_FOUND,
            component:   'notFound'
        },

        /** Homepage - Explore options. */
        stateExplore = {
            parent:      stateRoot,
            name:        CONFIG.STATES.EXPLORE,
            url:         '/',
            component:   'explorePage'
        },

        /** Study area - detail. */
        stateStudyAreas = {
            parent:     stateRoot,
            name:       CONFIG.STATES.STUDY_AREA,
            url:        '/' + CONFIG.ROUTES.STUDY_AREAS + '/:' + CONFIG.PARAMS.STUDY_AREA_ID + '?' + CONFIG.PARAMS.SUBJECT +
                            '&' + CONFIG.PARAMS.INTERNATIONAL,
            component:  'studyAreaPage',
            params:     studyAreasParamsSet
        },

            // Legacy about/ URL
            stateStudyAreasOldAbout = {
                parent:     stateRoot,
                name:      'study-areas#old-about',
                url:        '/' + CONFIG.ROUTES.STUDY_AREAS + '/:' + CONFIG.PARAMS.STUDY_AREA_ID + '/about?' + CONFIG.PARAMS.SUBJECT +
                            '&' + CONFIG.PARAMS.INTERNATIONAL,
                params:     studyAreasParamsSet
            },

            /**
             * Possible children - The order of their declarations determines
             * order of items in menus.
             */
            stateStudyAreasDefaultSubpage = bindChildStateWithParent( stateStudyAreas, {
                name:      CONFIG.STATES.STUDY_AREAS.ABOUT,
                url:       '/overview',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( stateStudyAreas, { // eslint-disable-line no-unused-vars
                name:      CONFIG.STATES.STUDY_AREAS.PEOPLE,
                url:       '/people',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( stateStudyAreas, { // eslint-disable-line no-unused-vars
                name:      CONFIG.STATES.STUDY_AREAS.STUDY,
                url:       '/study',
                component: 'studySubpage',
            }),

        /** Postgraduate study area - detail. */
        statePostgradAreas = {
            parent:         stateRoot,
            name:           CONFIG.STATES.POSTGRAD_AREA,
            url:            '/' + CONFIG.ROUTES.POSTGRAD_AREAS + '/:' + CONFIG.PARAMS.POSTGRAD_AREA_ID + '?' + CONFIG.PARAMS.INTERNATIONAL,
            component:     'postgradAreaPage',
            params:        postgradAreasParamsSet
        },

            // Legacy about/ URL
            statePostgradAreasOldAbout = {
                parent:         stateRoot,
                name:           'postgrad-area#old-about',
                url:            '/' + CONFIG.ROUTES.POSTGRAD_AREAS + '/:' + CONFIG.PARAMS.POSTGRAD_AREA_ID + '/about?' + CONFIG.PARAMS.INTERNATIONAL,
                params:        postgradAreasParamsSet
            },

            /**
             * Possible children - The order of their declarations determines
             * order of items in menus.
             */
            statePostgradAreasDefaultSubpage = bindChildStateWithParent( statePostgradAreas, {
                name:      CONFIG.STATES.POSTGRAD_AREAS.ABOUT,
                url:       '/overview',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( statePostgradAreas, {
                name:      CONFIG.STATES.POSTGRAD_AREAS.QUALIFICATIONS,
                url:       '/qualifications',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( statePostgradAreas, {
                name:      CONFIG.STATES.POSTGRAD_AREAS.PEOPLE,
                url:       '/people',
                component: 'genericSubpage'
            }),

            /** Postgraduate + Graduate qualification - detail. */
            statePostgrads = {
                parent:         stateRoot,
                name:           CONFIG.STATES.POSTGRAD,
                url:            '/{' + CONFIG.PARAMS.QUAL_TYPE + ':' + CONFIG.ROUTES.POSTGRADS + '|' + CONFIG.ROUTES.GRADUATE_QUALS + '|' + CONFIG.ROUTES.OTHER_QUALS + '}/:' + CONFIG.PARAMS.POSTGRAD_ID + '?' + CONFIG.PARAMS.SUBJECT +
                '&' + CONFIG.PARAMS.SPECIALISATION + 
                                    '&' + CONFIG.PARAMS.PROGRAMME +
                                    '&' + CONFIG.PARAMS.INTERNATIONAL,
                component:      'postgradPage',
                params:         postgradsParamsSet
            },

            // Legacy about/ URL
            // TODO: Remove after all about/ routes disappear from the web
            statePostgradsOldAbout = {
                parent:         stateRoot,
                name:           'postgrads#old-about',
                url:            '/{' + CONFIG.PARAMS.QUAL_TYPE + ':' + CONFIG.ROUTES.POSTGRADS + '|' + CONFIG.ROUTES.GRADUATE_QUALS + '|' + CONFIG.ROUTES.OTHER_QUALS + '}/:' + CONFIG.PARAMS.POSTGRAD_ID + '/about?' + CONFIG.PARAMS.SUBJECT +
                                    '&' + CONFIG.PARAMS.PROGRAMME +
                                    '&' + CONFIG.PARAMS.INTERNATIONAL,
                params:         postgradsParamsSet
            },

            /**
             * Possible children - The order of their declarations determines
             * order of items in menus.
             */
            statePostgradsDefaultSubpage = bindChildStateWithParent( statePostgrads, {
                name:      CONFIG.STATES.POSTGRADS.ABOUT,
                url:       '/overview',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( statePostgrads, {
                name:      CONFIG.STATES.POSTGRADS.STUDY,
                url:       '/study-details',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( statePostgrads, {
                name:      CONFIG.STATES.POSTGRADS.REQUIREMENTS,
                url:       '/requirements',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( statePostgrads, {
                name:      CONFIG.STATES.POSTGRADS.PEOPLE,
                url:       '/people',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( statePostgrads, {
                name:      CONFIG.STATES.POSTGRADS.APPLY,
                url:       '/apply-contact',
                component: 'genericSubpage'
            }),

        /** Degree - detail. */
        stateDegrees = {
            parent:         stateRoot,
            name:           CONFIG.STATES.DEGREE,
            url:            '/' + CONFIG.ROUTES.DEGREES + '/:' + CONFIG.PARAMS.DEGREE_ID + '?' + CONFIG.PARAMS.PRIMARY_MAJOR +
                                '&' + CONFIG.PARAMS.SECONDARY_MAJOR +
                                '&' + CONFIG.PARAMS.INTERNATIONAL,
            component:      'degreePage',
            params:         degreesParamsSet
        },

            // Legacy about/ URL
            stateDegreesOldAbout = {
                parent:         stateRoot,
                name:           'degrees#old-about',
                url:            '/' + CONFIG.ROUTES.DEGREES + '/:' + CONFIG.PARAMS.DEGREE_ID + '/about?' + CONFIG.PARAMS.PRIMARY_MAJOR +
                                    '&' + CONFIG.PARAMS.SECONDARY_MAJOR +
                                    '&' + CONFIG.PARAMS.INTERNATIONAL,
                params:         degreesParamsSet
            },

            /**
             * Possible children - The order of their declarations determines
             * order of items in menus.
             */
            stateDegreesDefaultSubpage = bindChildStateWithParent( stateDegrees, {
                name:      CONFIG.STATES.DEGREES.ABOUT,
                url:       '/overview',
                component: 'genericSubpage'
            }),

            subpageState = bindChildStateWithParent( stateDegrees, {
                name:      CONFIG.STATES.DEGREES.REQUIREMENTS,
                url:       '/requirements',
                component: 'genericSubpage'
            });

            subpageState = bindChildStateWithParent( stateDegrees, {
                name:      CONFIG.STATES.DEGREES.APPLY,
                url:       '/apply',
                component: 'genericSubpage'
            });


        /* ===== ON INITIALISATION ========================================== */

        /** @constructor */
        (function init(){
            configureHttpClient();
            configureRouter();
            bindStates();
        })();


        /* ===== PRIVATE FUNCTIONS ========================================== */

        function bindStates() {
            defineRedirects();

            // Bind states
            $stateProvider
                .state( stateRoot )
                .state( stateExplore )
                .state( stateStudyAreas )
                .state( statePostgradAreas )
                .state( statePostgrads )
                .state( stateDegrees )
                .state( stateServer404 )// *MUST HAVE* two #404 variations due
                .state( state404 );     // to the $state's internal limitiations
        }


        function defineRedirects() {
            stateRoot.redirectTo            = stateExplore.name;
            stateExplore.redirectTo         = function() {
                // Hard redirect
                if ( AppProvider.$get().isPublicMode() ){
                    window.location.href = CONFIG.REDIRECTS.TOPICS_URL; /* eslint angular/window-service: 0 */
                }

                return;
            };

            // Defaults for the main page categories
            stateStudyAreas.redirectTo      = stateStudyAreasDefaultSubpage.name;
            //statePostgradAreas.redirectTo   = statePostgradAreasDefaultSubpage.name;

            statePostgradAreas.redirectTo   = statePostgradAreasDefaultSubpage.name;

            statePostgrads.redirectTo       = statePostgradsDefaultSubpage.name;
            stateDegrees.redirectTo         = stateDegreesDefaultSubpage.name;

            // Redirects for the legacy URLs
            stateStudyAreasOldAbout.redirectTo = stateStudyAreasDefaultSubpage.name;

            statePostgradAreasOldAbout.redirectTo = statePostgradAreasDefaultSubpage.name;

            statePostgradsOldAbout.redirectTo = statePostgradsDefaultSubpage.name;

            stateDegreesOldAbout.redirectTo = stateDegreesDefaultSubpage.name;

            $stateProvider
                .state( stateStudyAreasOldAbout )
                .state( statePostgradAreasOldAbout )
                .state( statePostgradsOldAbout )
                .state( stateDegreesOldAbout );
        }


        function whitelistAccessedUrls() {
            $sceDelegateProvider.resourceUrlWhitelist([
                'self', // Allow same origin resource loads.

                CONFIG.URLS.SHARED_ASSETS + '**', // Allow loading from our shared assets domain.  Notice the difference between * and **.

                CONFIG.MODES.ADMIN.API.CMS.BASE_URL + '**', // Allow loading from API for administrators.
                CONFIG.MODES.STAGE.API.CMS.BASE_URL + '**', // Allow loading from API for stage content
                CONFIG.MODES.PUBLIC.API.CMS.BASE_URL + '**', // Allow loading from API for public visitors.

                CONFIG.URLS.VICTORIA_SEARCH
            ]);
        }


        function configureHttpClient() {
            whitelistAccessedUrls();

            // Reset headers to avoid OPTIONS request (aka preflight)
            $httpProvider.defaults.headers.common = {};
            $httpProvider.defaults.headers.post   = {};
            $httpProvider.defaults.headers.put    = {};
            $httpProvider.defaults.headers.patch  = {};
        }


        function configureRouter() {
            // Remove # from URL (Note: base in index.html *MUST BE* correctly set)
            $locationProvider.html5Mode({
                enabled:     true,
                requireBase: true
            });

            $locationProvider.hashPrefix( '!' );

            // Make trailing slash optional
            $urlMatcherFactoryProvider.strictMode( false );
        }


        /**
         * Adds reference to the parental State Definition Object
         * to 'parent' attribute on child's State Definition
         * Object and pushes its reference into the parent's
         * 'children' array.
         *
         * @param {uirouter.StateDeclaration} parentStateDefinition
         * @param {uirouter.StateDeclaration} childStateDefinition
         *
         * @returns {uirouter.StateDeclaration}
         */
        function bindChildStateWithParent( parentStateDefinition, childStateDefinition ) {
            if ( !parentStateDefinition.hasOwnProperty( 'children' ) ) parentStateDefinition.children = [];

            // Decorate $state declaration with extra fields
            parentStateDefinition.children.push( childStateDefinition )
            childStateDefinition.parent = parentStateDefinition;

            // Inject it to the ui-router
            $stateProvider.state( childStateDefinition );

            return childStateDefinition;
        }
    }
})();
